export const SET_DESIGNER_MODE = 'SET_DESIGNER_MODE'
export const SET_DESIGNER_OBJ = 'SET_DESIGNER_OBJ'
